import React, { type ComponentType, type FC } from 'react'

import {
  evalCondition,
  notifyParent,
  sessionStoreGet,
  STORE_KEY_AUTH,
  useConsoleTracking,
  usePageTracking,
} from 'mailup-react-helpers'


interface W {
  location: {
    pathname: string
    search: string
  }
}

export const getPathname = (w: W = window): string => {
  const pname = w.location.pathname.replace(/^\/[^/]+(\/.*)/, '$2')

  return pname
}

export const onboard = (w: W = window): void => {
  const {
    location: { search },
  } = w

  const pname = getPathname(w)

  notifyParent('redirectMainFrame', [
    `filters_app_redirector.aspx?r=${encodeURIComponent(`${pname}${search}`)}`,
  ])
}

export const withAuth = (
  Component: ComponentType,
  FallbackComponent: ComponentType,
  condition: string,
  onMissingAuth = onboard,
  extraProps = {},
): ComponentType => {
  const WithAuthComponent: FC = (props) => {
    const auth: Record<string, unknown> = sessionStoreGet(STORE_KEY_AUTH)

    usePageTracking(getPathname())
    useConsoleTracking()

    if (auth === null) {
      onMissingAuth()

      return null
    }

    if (condition.length > 0) {
      const conditionIsSatisfied: boolean = evalCondition(condition)

      if (!conditionIsSatisfied) {
        return <FallbackComponent />
      }
    }

    return <Component {...props} {...extraProps} />
  }

  return WithAuthComponent
}
